import React from 'react'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'
import { GreySection } from '../../../../components/section'
import { PrimaryText, SectionTitle } from '../atom'

const Picture = styled.img`
  display: block;
  max-width: 976px;
  margin: 65px auto 0;
  ${media.max.md`
    margin: 27px auto 0;
    max-width: 89vw;
  `}
`

export interface SolutionProps {
  menuData: any
  customizeStyle?: React.CSSProperties
}

export function Solution(props: SolutionProps) {
  const { menuData, customizeStyle } = props
  const styles = { marginBottom: '30px' }
  return (
    <GreySection>
      <SectionTitle style={styles}>解决方案</SectionTitle>
      <PrimaryText>{menuData.description}</PrimaryText>
      <Picture src={menuData.icon} alt='' style={customizeStyle} />
    </GreySection>
  )
}
